import { DropdownMenu, DropdownMenuContent, DropdownMenuGroup, DropdownMenuItem, DropdownMenuTrigger } from "@/components/core/actions/dropdown-menu";
import { Button } from "@/components/core/buttons/button";
import DataTable, { type ColumnDef } from "@/components/core/data-table.tsx";
import { useModal } from "@/components/core/modals/use-modal";
import { Content } from "@/components/layouts/content";
import { Header } from "@/components/layouts/header";
import { categoryQueryOptions } from "@/features/dashboard/api/queries/look-up-item-queries";
import lookUptItemService from "@/features/dashboard/api/services/look-up-item-service";
import LookUpItem from "@/features/dashboard/components/settings-lookupitem-modal";
import type { Category } from "@/features/dashboard/types/categories";
import { queryClient } from "@/query-client";
import { IconChevronDown, IconPlus } from "@tabler/icons-react";
import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { useParams } from "@tanstack/react-router";
import { toast } from "sonner";

const columns: ColumnDef<Category>[] = [
	{
		id: "name",
		label: "Category Name",
		cell: ({ data }) => <span className="font-bold text-foreground-dark">{data.caseCategory?.name}</span>,
	},
	{
		id: "name",
		label: "Category Type",
		cell: ({ data }) => <span className="font-bold text-foreground-dark">{data.caseType?.name}</span>,
	},
];

export const Route = createFileRoute("/_dashboard/branch_/$branchId")({
	component: RouteComponent,
});

function RouteComponent() {
	const modal = useModal();
	const { branchId } = useParams({ from: "/_dashboard/branch_/$branchId" });
	const branchName = new URLSearchParams(location.search).get("name");

	const categoryQuery = useSuspenseQuery(
		categoryQueryOptions({
			// ...search,
			branchId: branchId,
		}),
	);
	const category = categoryQuery.data.data;

	const handleDelete = async (row: Category) => {
		await lookUptItemService.deleteById(row.id as string);
		await queryClient.invalidateQueries({
			queryKey: ["category"],
		});
		toast.success("Category successfully deleted.");
	};

	return (
		<Content pageName="Branch">
			{/*<Header title="Branch" />*/}
			<div className="flex flex-col w-full max-w-base p-6 gap-6">
				<div className="flex flex-row items-center justify-between w-full gap-4">
					<div className="inline-flex flex-col w-auto">
						<span className="text-xl text-foreground-dark font-semibold">{branchName}</span>
						<span className="text-base text-foreground/70">Branch category description for help here</span>
					</div>
					<DropdownMenu modal={false}>
						<DropdownMenuTrigger asChild>
							<Button>
								Actions
								<IconChevronDown size={16} stroke={2} />
							</Button>
						</DropdownMenuTrigger>
						<DropdownMenuContent>
							<DropdownMenuGroup>
								<DropdownMenuItem
									onSelect={() =>
										modal.openModal({
											title: "Create Category",
											description: "",
											component: <LookUpItem branchId={branchId} />,
										})
									}
								>
									<div className="flex flex-row items-center w-full py-1 px-2 gap-1">
										<IconPlus size={16} stroke={2} />
										<span className="inline-flex">New Record</span>
									</div>
								</DropdownMenuItem>
							</DropdownMenuGroup>
						</DropdownMenuContent>
					</DropdownMenu>
				</div>
				<div className="flex flex-col w-full gap-4">
					<DataTable
						showToolbar={true}
						data={category}
						columns={columns}
						showBorder={true}
						compact={true}
						// onDelete={(row) => handleDelete(row)}
						onDelete={handleDelete}
					/>
				</div>
			</div>
		</Content>
	);
}
